import {saConfig} from '@spero/spero-utils/src/constants/saConfig'

const config = {
  test: {
    bucket: 'spero-dev',
    endpoint: 'https://dev-oss.secon.cn',
    rootApi: {
      baseURL: 'https://dev-outspace.secon.cn/'
    },
    jindashiApi: {
      baseURL: 'https://fw-api.dyzt88.com.cn'
    },
    saApi: saConfig.test
  },
  preview: {
    bucket: 'spero-prod',
    endpoint: 'https://oss.secon.cn',
    rootApi: {
      baseURL: 'https://spero-outspace.secon.cn/'
    },
    jindashiApi: {
      baseURL: 'https://fw-api.dyzt88.com.cn'
    },
    saApi: saConfig.prod
  },
  production: {
    bucket: 'spero-prod',
    endpoint: 'https://oss.secon.cn',
    rootApi: {
      baseURL: 'https://spero-outspace.secon.cn/'
    },
    jindashiApi: {
      baseURL: 'https://fw-api.dyzt88.com.cn'
    },
    saApi: saConfig.prod
  }
}

const noEnvConfig = {
  appid: 'wx4f982eecd45caddf',
  platform: 'Hawkeye',
  // appid: 'wx5eb8abb782d660a9',
  // platform: 'GROOT',
  signatureURL: '/public/jssdk/config',
  region: 'oss-cn-shanghai'
}
console.log('process.env.VUE_APP_ENV=', process.env.VUE_APP_ENV)
export default Object.assign(config[process.env.VUE_APP_ENV || 'test'], noEnvConfig)
